<script setup lang="ts">
import {
  NavigationMenuLink,
  type NavigationMenuLinkEmits,
  type NavigationMenuLinkProps,
  useForwardPropsEmits
} from 'reka-ui';

const props = defineProps<NavigationMenuLinkProps>();
const emits = defineEmits<NavigationMenuLinkEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <NavigationMenuLink
    v-bind="forwarded"
    tabindex="0"
    @keyup.enter="(e: CustomEvent<{ originalEvent: Event }>) => $emit('select', e)"
  >
    <slot />
  </NavigationMenuLink>
</template>
